<script setup lang="ts">
definePageMeta({
  title: 'About Us',
  label: 'About',
  description: 'Integrated Cable Systems (ICS) is a Colorado-based supplier of specialized cable assemblies, wire harnesses, and electro-mechanical assemblies.',
  order: 6,
})

const route = useRoute()

const atAboutRoot = computed(() => /\/about\/?$/.test(route.path))
</script>

<template>
  <PageRoot class="min-h-screen relative">
    <PageHead
      theme="dark"
      :at-root="atAboutRoot"
    >
      <template #parallax>
        <EffectBgMountains v-if="!atAboutRoot" />
      </template>
    </PageHead>
    <PageBody class="text-white relative z-100">
      <BlockContent
        v-if="atAboutRoot"
        class="pb-12 drop-shadow drop-shadow-color-black/70 space-y-12"
      >
        <section class="leading-loose max-w-prose space-y-8 sm:text-xl sm:leading-loose">
          <p class="text-lg leading-loose sm:text-2xl sm:leading-loose">
            Integrated Cable Systems (ICS) is an ISO 9001:2015 & AS9100D certified, Colorado-based supplier of specialized cable assemblies, wire harnesses, and electro-mechanical assemblies.
          </p>
          <p>
            We are a turn-key supplier that works intimately with our customers to provide solutions to their most critical issues. Our core services include but are not limited to: engineering services, cable assembly and wire harness manufacturing, the development of customer documentation, as well as testing a broad range of custom interconnect products to ensure compliance and performance. ICS brings decades of technical and manufacturing engineering experience coupled with a singular passion for helping customers to “get it right.” We take great pride in providing outstanding engineering support and service.
          </p>
        </section>
        <section class="leading-loose max-w-prose space-y-4 sm:text-xl sm:leading-loose">
          <h2 class="heading-strong">
            Mission Statement
          </h2>
          <p>As a comprehensive provider of custom cable assemblies, wire harnesses, electro-mechanical assemblies, and industrial panels, ICS delivers innovative connectivity solutions. Our core strengths lie in engineering consultation, cable assembly and wire harness manufacturing, developing detailed customer documentation, and rigorously testing a wide array of custom interconnect products to ensure compliance and optimal performance.</p>
        </section>
        <section class="leading-loose max-w-prose space-y-4 sm:text-xl sm:leading-loose">
          <h2 class="heading-strong">
            Purpose
          </h2>
          <p>At ICS, we excel in tackling the most complex connectivity challenges. Our products are meticulously engineered to meet the stringent demands of high-cost-of-failure applications. We achieve this through our deep expertise, relentless innovation, unwavering customer focus, and a steadfast commitment to continuous growth and improvement.</p>
        </section>
        <section class="leading-loose max-w-prose space-y-4 sm:text-xl sm:leading-loose">
          <h2 class="heading-strong">
            Vision
          </h2>
          <p>At ICS, we envision a future where our innovative custom cable and harness solutions set the global standard for excellence in Aerospace, Defense, and Medical industries. Through our relentless pursuit of innovation, uncompromising quality, and deep expertise, we aim to become the premier turn-key provider for the world's leading Aerospace and Defense companies. Our commitment to solving the most challenging connectivity problems drives us to continuously improve and expand our capabilities, ensuring that we always deliver unparalleled performance and reliability in the most demanding environments.</p>
        </section>
      </BlockContent>
      <NuxtPage
        v-else
        class="text-icssilver-950"
      />
    </PageBody>
    <div class="inset-0 fixed">
      <EffectBgMountains v-if="atAboutRoot" />
    </div>
  </PageRoot>
</template>
